<template>
  <div class="chained__product">
    <a class="chained__product" :href="product.permalink" target="_blank">
      <div v-html="currentImage"></div>
    </a>
    <div class="chained__name">{{ product.name }}</div>
    <div class="chained__price">
      <del>{{
          Intl.NumberFormat('fr-FR', {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 0,
          }).format(currentPrice)
        }}
      </del>
      <span>{{
          Intl.NumberFormat('fr-FR', {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 0,
          }).format(0)
        }}</span>
    </div>
    <div>
      <select v-if="product.type.includes('variable')" v-model.number="variationId">
        <option v-for="variation in product.variations" :value="variation.id">
          {{ variation.attributeSummary }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChainedProduct",
  props: {
    product: {
      type: Object,
    },
  },
  data() {
    return {
      variationId: '',
    }
  },
  watch: {
    variationId(val) {
      let selectors = `[name="chained_${this.product.id}_variation_id"]`
      document.querySelector(selectors).value = val
      selectors = `[name="chained_${this.product.id}_attributes"]`
      document.querySelector(selectors).value = JSON.stringify(this.currentVariation.attributes)
    },
  },
  computed: {
    currentVariation() {
      if (this.product.type.includes('variable')) {
        if (this.product.variations.length >= 1) {
          const index = this.product.variations.findIndex(variation => variation.id === this.variationId);
          if (index > -1) {
            return this.product.variations[index]
          }
        }
      }
      return {}
    },
    currentImage() {
      if (this.product.type.includes('variable')) {
        if (this.product.variations.length >= 1) {
          const index = this.product.variations.findIndex(variation => variation.id === this.variationId);
          if (index > -1) {
            return this.product.variations[index].img_html
          }
        }
      }
      return this.product.img_html;
    },
    currentPrice() {
      if (this.currentVariation.hasOwnProperty('price')) {
        return this.currentVariation.price
      }
      return this.product.price;
    },
  },
  beforeMount() {
    if (this.product.type.includes('variable')) {
      this.variationId = this.product.variations[0].id
    }
  },
}
</script>

<style scoped lang="scss">
.chained__product {
  padding: 1rem 2rem;

  .chained__product { // a
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .chained__name {
    min-height: 48px;
  }

  .chained__price {
    font-style: italic;

    del {
      color: grey;
    }

    span {
      color: var(--green);
      margin-left: 1rem;
      font-weight: bold;
    }
  }

  select {
    height: 4rem;
    padding: .5rem 1rem;
  }

}
</style>
